import React, { useRef, useEffect } from "react";
import ChatMessage from "./ChatMessage";
import ChatDateDivider from "./ChatDateDivider";

const formatDateLabel = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);

  if (date.toDateString() === today.toDateString()) {
    return "Hoy";
  } else if (date.toDateString() === yesterday.toDateString()) {
    return "Ayer";
  } else {
    return date.toLocaleDateString([], {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  }
};

const ChatMessages = ({ messages = [], onImagePreview }) => {
  const bottomRef = useRef(null);

  useEffect(() => {
    // Scroll suave hacia abajo cuando cambia la cantidad de mensajes
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages.length]);

  const dedupedMessages = React.useMemo(() => {
    const seenIds = new Set();
    const seenContent = new Set();

    return messages.filter((msg) => {
      // Deduplicación estricta por ID o messageSid
      const idKey = msg?.id || msg?._id || msg?.messageSid;
      if (idKey && seenIds.has(idKey)) {
        return false;
      }

      // Deduplicación por contenido + tiempo aproximado (mismo minuto)
      let timeKey = "";
      if (msg?.dataSend) {
        const d = new Date(msg.dataSend);
        timeKey = `${d.getFullYear()}-${d.getMonth()}-${d.getDate()} ${d.getHours()}:${d.getMinutes()}`;
      }

      const contentKey = `${msg?.text || ""}-${msg?.type || ""}-${timeKey}`;

      if (seenContent.has(contentKey)) {
        return false;
      }

      if (idKey) {
        seenIds.add(idKey);
      }
      seenContent.add(contentKey);
      return true;
    });
  }, [messages]);

  const renderedElements = [];
  let lastDateLabel = "";

  dedupedMessages.forEach((msg, index) => {
    const isOwn = msg.type === "supervisor-cabin";
    const dateLabel = formatDateLabel(msg.dataSend);

    // Si la fecha cambia respecto al mensaje anterior, agregamos un divisor de fecha
    if (dateLabel && dateLabel !== lastDateLabel) {
      renderedElements.push(
        <ChatDateDivider key={`date-${dateLabel}-${index}`} date={dateLabel} />
      );
      lastDateLabel = dateLabel;
    }

    renderedElements.push(
      <ChatMessage
        key={msg.messageSid || msg.id || msg._id || `${msg.text}-${index}`}
        text={msg.text}
        isOwn={isOwn}
        time={msg.dataSend}
        isImage={msg.class === "image"}
        onImageClick={onImagePreview}
        status={msg.status}
      />
    );
  });

  return (
    <div style={styles.container}>
      <div style={styles.scrollArea}>
        {renderedElements}
        <div ref={bottomRef} />
      </div>
    </div>
  );
};

const styles = {
  container: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    position: "relative",
    backgroundColor: "transparent",
  },
  scrollArea: {
    flex: 1,
    overflowY: "auto",
    padding: "16px 12px",
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
};

export default ChatMessages;
